import { post } from '@/utils/request'

/**
 * 通知内容增加
 * @param {String}  title 通知标题
 * @param {String} content 通知内容
  */
export function admin_public_notice_add(data) {
  return post('admin_public_notice_add', data)
}

/**
 * 通知内容删除
 * @param {String}  id 通知id
 */
export function admin_public_notice_delete(data) {
  return post('admin_public_notice_delete', data)
}

/**
 * 通知内容修改
 * @param {String}  id 通知id
 * @param {String}  title 通知标题
 * @param {String} content 通知内容
 */
export function admin_public_notice_edit(data) {
  return post('admin_public_notice_edit', data)
}

/**
 * 通知置顶
 * @param {String}  id 通知id
 */
export function admin_public_notice_set_top(data) {
  return post('admin_public_notice_set_top', data)
}
/**
 * 通知取消置顶
 * @param {String}  id 通知id
 */
export function admin_public_notice_set_untop(data) {
  return post('admin_public_notice_set_untop', data)
}

/**
 * 通知内容详情
 * @param {String}  id 通知id
 */
export function admin_public_notice_info(data) {
  return post('admin_public_notice_info', data)
}

/**
 * 通知列表
 */
export function admin_public_notice_list(data) {
  return post('admin_public_notice_list', data)
}

/**
 * 淘客查看通知详情
 */
export function taoke_public_notice_info(data) {
  return post('taoke_public_notice_info', data)
}

/**
 * 淘客查看通知列表
 */
export function taoke_public_notice_list(data) {
  return post('taoke_public_notice_list', data)
}